import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { AirportService } from '../../airport/airport.service';
import { TagService } from '../../shared/services/tag.service';
import { hasTag } from '../../util/tag-utils';
var EditCommunicationComponent = /** @class */ (function () {
    function EditCommunicationComponent(matDialogRef, data, businessManagerService, _airportService, _tagService, snackBar) {
        this.matDialogRef = matDialogRef;
        this.data = data;
        this.businessManagerService = businessManagerService;
        this._airportService = _airportService;
        this._tagService = _tagService;
        this.snackBar = snackBar;
        this.isLoading = true;
        this.monitorsCTAF = false;
        this.business = data.business;
    }
    EditCommunicationComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var allTags, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.formGroup = new FormGroup({
                            arincFreq: new FormControl(this.business.arincFreq, [Validators.nullValidator, Validators.pattern('^[0-9]{3}\.[0-9]{1,3}$')]),
                            unicomFreq: new FormControl(this.business.unicomFreq, [Validators.nullValidator, Validators.pattern('^[0-9]{3}\.[0-9]{1,3}$')]),
                            monitoringCTAF: new FormControl(false)
                        });
                        this.isLoading = false;
                        this.formGroup.patchValue({ arincFreq: this.formatFrequency(this.business.arincFreq) || '' });
                        this.formGroup.patchValue({ unicomFreq: this.formatFrequency(this.business.unicomFreq) || '' });
                        return [4 /*yield*/, this._tagService.getAllTags()];
                    case 1:
                        allTags = _b.sent();
                        _a = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'Monitor CTAF')];
                    case 2:
                        _a.monitorsCTAFTag = _b.sent();
                        this.monitorsCTAF = hasTag(this.business.tags, 'Monitor CTAF');
                        if (this.monitorsCTAF) {
                            this.formGroup.patchValue({ monitoringCTAF: true });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    EditCommunicationComponent.prototype.formatFrequency = function (frequency) {
        if (frequency && Number(frequency) % 1 === 0) {
            // The frequency is an integer
            return frequency.toString() + '.0';
        }
        else {
            return frequency;
        }
    };
    /**
     * closes modal
     */
    EditCommunicationComponent.prototype.close = function (result) {
        if (result === void 0) { result = { cancelBtnClicked: true, success: false }; }
        if (result) {
            this.matDialogRef.close(result);
        }
    };
    /**
     * submits form values to api server if formGroup.valid property is true
     * @return {Promise<void>}
     */
    EditCommunicationComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var TEMP_BUSINESS, _a, e_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        TEMP_BUSINESS = this.business;
                        if (!this.formGroup.valid) {
                            return [2 /*return*/];
                        }
                        // form values are mapped to business object before api call.
                        this.business.arincFreq = this.formGroup.value.arincFreq;
                        this.business.unicomFreq = this.formGroup.value.unicomFreq;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 8, , 9]);
                        return [4 /*yield*/, this.businessManagerService.updateBusiness(this.business)];
                    case 2:
                        _b.sent();
                        if (!(!this.monitorsCTAF && this.formGroup.controls.monitoringCTAF.value)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._tagService.postTag(this.monitorsCTAFTag.tagId, this.business.id)];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        if (!(this.monitorsCTAF && !this.formGroup.controls.monitoringCTAF.value)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._tagService.deleteTag(this.monitorsCTAFTag.tagId, this.business.id)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getBusiness(this.business.id.toString())];
                    case 7:
                        _a.business = _b.sent();
                        this.close({ cancelBtnClicked: false, success: true });
                        return [3 /*break*/, 9];
                    case 8:
                        e_1 = _b.sent();
                        this.snackBar.open('Failed to save Monitoring CTAF setting', 'Error', {
                            duration: 6000
                        });
                        this.business = TEMP_BUSINESS;
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    return EditCommunicationComponent;
}());
export { EditCommunicationComponent };
